import * as React from 'react'
import { FC, useMemo } from 'react'
import { useField, useFormikContext } from 'formik'
import CollapsibleFilter from '../atoms/CollapsibleFilter'
import {
  IPropsWithProvider,
  SingleSelect,
  IFilterProps,
  OptionDependency,
} from '../../typings'

import Grid from '@mui/material/Grid'
import { SingleSelectAutoComplete } from './SingleSelectAutoComplete'

interface Props extends IFilterProps, IPropsWithProvider {
  dependsOn?: OptionDependency
}

export const SingleSelectFilter: FC<Props> = ({
  name,
  label,
  component,
  dependsOn,
  reset,
}) => {
  const path = `filters.${name}.value`

  const { setFieldValue } = useFormikContext()
  const [{ value }] = useField<SingleSelect>(path)

  const setValue = React.useCallback(
    (value: SingleSelect) => void setFieldValue(path, value),
    [path, setFieldValue],
  )

  const subLabel = useMemo(() => (value ? value.label : ''), [value])

  const [dep, setDep] = React.useState(dependsOn)

  React.useEffect(() => {
    if (dependsOn !== undefined && dependsOn !== dep) {
      setDep(dependsOn)
      setValue(null)
    }
  }, [dep, dependsOn, setValue])

  return (
    <CollapsibleFilter
      label={label}
      subLabel={(expanded) => !expanded && subLabel}
      reset={reset}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <SingleSelectAutoComplete
            value={value}
            setValue={setValue}
            dependsOn={dep}
            component={component}
          />
        </Grid>
      </Grid>
    </CollapsibleFilter>
  )
}
SingleSelectFilter.displayName = 'SingleSelectFilter'
